import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class RoleApi extends BaseApi {
    constructor(client) {
        super(client, '/role');
    }

    /**
     * @param {string} roleId
     * @param {string[]} userIds
     */
    async assignUsers(roleId, userIds) {
        try {
            const response = await this.client.post(`${this.basePath}/${roleId}/assign-users`, { userIds });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    /**
     * Replace the units (units) linked to this role.
     * @param {string} roleId
     * @param {string[]} unitIds
     */
    async setUnits(roleId, unitIds) {
        try {
            const response = await this.client.put(`${this.basePath}/${roleId}/units`, { unitIds });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    /**
     * Replace the per-unit user assignments for this role.
     * @param {string} roleId
     * @param {Array<{ unit: string, user: string|null }>} assignments
     * @param {{ forceReplace?: boolean, merge?: boolean }} [options]
     */
    async setUnitAssignments(roleId, assignments, options = {}) {
        try {
            const response = await this.client.put(
                `${this.basePath}/${roleId}/unit-assignments`,
                {
                    assignments,
                    forceReplace: Boolean(options.forceReplace),
                    merge: Boolean(options.merge),
                }
            );
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    /**
     * List the unit-roles available for a given unit (Units page).
     * @param {string} unitId
     */
    async listUnitRolesForUnit(unitId) {
        try {
            const response = await this.client.get(
                `${this.basePath}/unit-roles/for-unit/${unitId}`
            );
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
